/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import sortBy from 'lodash/sortBy';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

// import useScrollToTop from '../../hooks/useScrollToTop';
import Blocks from '../blocks/Blocks';
import Property from '../partials/Property';
import Background from '../partials/SectionPageBackground';

import styles from '../../../styles/pages/media.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
    site: AppPropTypes.site.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const MediaPage = ({ page, site, className }) => {
    const { properties = [], blocks = null, handle = null } = page || {};
    const { handle: siteHandle = null } = site || {};

    const finalProperties = useMemo(() => {
        if (siteHandle !== null) {
            return sortBy(properties, (property) => {
                const { handle: propertyHandle = null } = property || {};
                return propertyHandle === siteHandle ? -1 : 0;
            });
        }
        return properties;
    }, [siteHandle, properties]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <Background className={styles.header} pageHandle={handle} />
            <div className={styles.content}>
                {blocks !== null ? (
                    <Blocks
                        className={styles.blocks}
                        blocks={blocks.map((block) => {
                            const { type } = block;
                            return type === 'gallery'
                                ? {
                                      ...block,
                                      imageClassName: styles.gallery,
                                  }
                                : block;
                        })}
                        isContainer
                        firstInPage
                        typeClassName={{
                            title: styles.title,
                        }}
                    />
                ) : null}
                {finalProperties.length > 0 ? (
                    <div className={styles.properties}>
                        {(finalProperties || [])
                            .filter(({ published = false }) => published !== false)
                            .map((property, idx) => (
                                <Property
                                    key={`property-${idx + 1}`}
                                    className={styles.property}
                                    {...property}
                                />
                            ))}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

MediaPage.propTypes = propTypes;
MediaPage.defaultProps = defaultProps;

export default MediaPage;
